module.exports = __webpack_public_path__ + "static/media/volun-image-desktop-2.afc97670.png";